import React, { useEffect, useState } from "react";
import SC from "./style";
import {
  Breadcrumbs,
  DetailDrawer,
  InnoTable,
  Popover,
  TableList,
} from "InnoUI/components";
import { useLocation, useNavigate } from "react-router";
import { Switch } from "antd";
import theme from "theme";
import AddEditProjects from "./AddEditProjects";
import { apiGet, apiPost } from "api/callApi";
import { ImagePreview } from "components";
import { innoTableConfig, InnoTableDefaultPageSize } from "utils/config";
import AssignUser from "./AssignUser";
import FolderProjectStructure from "./FolderProjectStructure";
import { projectType } from "utils/lookUpTable";
import { readFromLocalStorage, showAlert } from "utils/helper";
import ExportPropertyModal from "components/ExportPropertyModal";
import LinkProjects from "./LinkProjects";
import ct from "countries-and-timezones";
import DeleteComponent from "../DeleteComponent";

const Projects = ({ popupState }) => {
  const location = useLocation();
  const [projects, setProjects] = useState([]);
  const [open, setOpen] = useState(false);
  const [openAssignUserDrawer, setopenAssignUserDrawer] = useState(false);
  const [openFolderStructure, setopenFolderStructure] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [rowData, setRowData] = useState();
  const [rowId, setRowId] = useState();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [openModal, setOpenModal] = useState(false);
  const [openDrwer, setOpenDrwer] = useState(false);
  const [countryOptions, setCountryOptions] = useState([]);
  const [openDeleteView, setOpenDeleteView] = useState(false);
  const [fieldId, setFieldId] = useState();
  const [pageSize, setPageSize] = useState(InnoTableDefaultPageSize.pageSize);

  const breadcrumbItems = [
    { label: "Admin Settings" },
    { label: "Projects", href: "/admin-settings/projects" },
  ];

  useEffect(() => {
    const allCountries = ct.getAllCountries();
    const countryList = Object.values(allCountries).map((country) => ({
      label: country.name,
      value: country.id,
    }));
    setCountryOptions(countryList);
  }, []);

  const countryFilter = {
    filters: countryOptions.map((option) => ({
      text: option.label,
      value: option.value,
    })),
    filterSearch: true,
    onFilter: (value, record) => record["countryName"] === value,
  };

  const closeAssignUserDrawer = () => {
    setopenAssignUserDrawer(false);
    setIsEditing(false);
  };

  const getAllProjects = async () => {
    try {
      setIsLoading(true);
      const response = await apiGet("/v1/projects", false);
      setProjects(response.data);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log("error", error);
    }
  };

  useEffect(() => {
    getAllProjects();
  }, []);

  const handleChange = async (id, property, value) => {
    try {
      const endpoint = `/v1/editproject/${id}`;
      const response = await apiPost(endpoint, { [property]: value });
      setProjects((prevProjects) =>
        prevProjects.map((project) =>
          project.id === id ? { ...project, [property]: value } : project
        )
      );
    } catch (error) {
      console.error("Error updating status:", error);
      showAlert({
        title: "Error",
        text: error?.response?.data?.message,
        icon: "error",
      });
    }
  };

  const closeDrawer = () => {
    setOpen(false);
    setIsEditing(false);
  };

  const onAddDataCallback = () => {
    setOpen(true);
    setRowData("");
    setIsEditing(false);
  };

  const handleExportClick = async (record) => {
    // navigate(`/downloadproject?projectId=${record.id}&type=${0}`);
    window.open(`/downloadproject?projectId=${record.id}&type=${0}`, "_blank");
  };

  const onRowClick = (data) => {
    setIsEditing(true);
    setRowData(data);
    setOpen(true);
    setRowId(data.id);
  };
  const onAssignUserClick = (data) => {
    setIsEditing(true);
    setRowData(data);
    setopenAssignUserDrawer(true);
    setRowId(data.id);
  };

  const handleProjectStructure = (record) => {
    setopenFolderStructure(true);
    setRowData(record);
  };

  const closeFolderStructure = () => {
    setopenFolderStructure(false);
    setRowData(null);
  };

  const handlelevelClick = (data) => {
    navigate(`/admin-settings/projects/level`, { state: { data } });
  };
  const handleOpenModal = (record) => {
    setOpenModal(true);
    setRowData(record);
  };

  const closeLinkProjectDrawer = () => {
    setOpenDrwer(false);
    setRowData(null);
  };

  const handleLinkProjects = (record) => {
    setOpenDrwer(true);
    setRowData(record);
  };

  const handleDeleteOpenModal = (record) => {
    setFieldId(record?.id);
    setRowData(record);
    setOpenDeleteView(true);
  };

  const handleDelete = async (projectId) => {
    try {
      const body = {
        projectId: projectId,
        projectType: projectType.property,
      };
      const response = await apiPost(`/v1/deleterequest`, body, false);
      showAlert({ title: "Success", text: response.message, icon: "success" });
      getAllProjects();
      setOpenDeleteView(false);
    } catch (error) {
      console.log(error.message);
    }
  };

  const renderText = (value) => <SC.ValueSpan>{value}</SC.ValueSpan>;

  const subColumnData = [
    {
      title: "S.No.",
      dataIndex: "id",
      width: 80,
      render(value, record, index) {
        const serialNumber = (currentPage - 1) * pageSize + index + 1;
        return <SC.ValueSpan>{serialNumber}</SC.ValueSpan>;
      },
    },
    {
      title: "Property Name",
      dataIndex: "propertyName",
      sorter: (a, b) => a.propertyName.localeCompare(b.propertyName),
      showSorterTooltip: { target: "sorter-icon" },
      sortDirections: ["ascend", "descend"],
      onCell: () => ({
        style: { width: "350px" },
      }),
      render(value, record) {
        const menuItems = [
          {
            id: 1,
            text: "Open",
            onClick: () => handlelevelClick(record),
          },
          {
            id: 2,
            text: "Edit",
            onClick: (event) => {
              event.stopPropagation();
              onRowClick(record);
            },
          },
          {
            id: 3,
            text: "Assign To User",
            onClick: (event) => {
              event.stopPropagation();
              onAssignUserClick(record);
            },
          },
          {
            id: 4,
            text: "Manage Folder Structure",
            onClick: (event) => {
              event.stopPropagation();
              handleProjectStructure(record);
            },
          },
          {
            id: 4,
            text: "Link Holiday",
            onClick: (event) => {
              event.stopPropagation();
              handleLinkProjects(record);
            },
          },
          {
            id: 5,
            text: "Export",
            onClick: (event) => {
              event.stopPropagation();
              handleOpenModal(record);
            },
          },
          {
            id: 6,
            text: "Delete",
            onClick: (event) => {
              event.stopPropagation();
              handleDeleteOpenModal(record);
            },
          },
        ];
        return (
          <SC.PopoverContainer>
            <SC.ValueSpanP>{value}</SC.ValueSpanP>

            <Popover
              sx={{
                cursor: "pointer",
              }}
              buttonLabel={{
                icon: (
                  <>
                    <div
                      style={{
                        width: "50px",
                        textAlign: "center",
                        justifyContent: "end",
                        display: "flex",
                        marginRight: "5px",
                      }}
                    >
                      <SC.PopoverSpan>
                        <SC.MoreVertIcon />
                      </SC.PopoverSpan>
                    </div>
                  </>
                ),
              }}
              popoverContent={
                <TableList
                  sx={{
                    borderBottom: `1px solid ${theme.colors.bordertask}`,
                  }}
                  items={menuItems || []}
                  popupState={popupState}
                />
              }
            />
          </SC.PopoverContainer>
        );
      },
    },
    {
      title: "Folder Template",
      dataIndex: "displayTemplateName",
      render: renderText,
    },
    {
      title: "Country Name",
      width: 200,
      dataIndex: "countryName",
      render(value, record) {
        const country = ct.getCountry(value);
        return <span>{country?.name}</span>;
      },
      ...countryFilter,
    },
    {
      title: "Linked Holidays",
      dataIndex: "totalHolidayCount",
      onCell: () => ({
        style: { padding: "0px 0px 0px 30px" },
      }),
      render(value, record) {
        return (
          <>
            <SC.PopoverContainer
              onClick={(e) => {
                e.stopPropagation();
                handleLinkProjects(record);
              }}
            >
              <SC.ValueSpanP
                style={{
                  color: "#eb7909",
                  opacity: "0.7",
                  textAlign: "center",
                  cursor: "pointer",
                  textDecoration: "underline",
                  fontWeight: "bold",
                }}
              >
                {value}
              </SC.ValueSpanP>
            </SC.PopoverContainer>
          </>
        );
      },
    },
    {
      title: "Images",
      dataIndex: "logoImage",
      render(value, record, index) {
        return (
          <>
            <ImagePreview width={40} src={`${value}`} />
          </>
        );
      },
    },
    {
      title: "Total Levels",
      dataIndex: "totalLevelCount",
      onCell: () => ({
        style: { padding: "0px 0px 0px 30px" },
      }),
      render(value, record, index) {
        return (
          <>
            <SC.PopoverContainer onClick={() => handlelevelClick(record)}>
              <SC.ValueSpanP
                style={{
                  color: "#eb7909",
                  opacity: "0.7",
                  textAlign: "center",
                  cursor: "pointer",
                  textDecoration: "underline",
                  fontWeight: "bold",
                }}
              >
                {value}
              </SC.ValueSpanP>
            </SC.PopoverContainer>
          </>
        );
      },
    },
    {
      title: "Status",
      dataIndex: "status",
      align: "center",
      render: (value, record) => (
        <Switch
          checked={value}
          onChange={(checked, event) => {
            event.stopPropagation();
            handleChange(record.id, "status", checked ? 1 : 0);
          }}
          style={{
            transform: "scale(0.7)",
            backgroundColor: value ? `${theme.colors.themeColor}` : undefined,
            borderColor: value ? `${theme.colors.themeColor}` : undefined,
          }}
        />
      ),
    },
  ];

  const tableConfig = {
    draggable: false,
    selection: false,
    expandable: true,
    sno: false,
    addNew: true,
    pagination: {
      current: currentPage, // current page number
      pageSize: pageSize, // page size state
      // pageSizeOptions: ["20", "50", "100"], // options shown in the dropdown
      showSizeChanger: true, // enable page size dropdown
      onChange: (page, pageSize) => {
        setCurrentPage(page);
        setPageSize(pageSize); // this is important to update
      },
    },

    search: true,
    action: false,
    divBorder: true,
    searchPlaceholder: "Search by Name and Template",
  };

  const handleBreadcrumbClick = (href) => {
    if (href) {
      navigate(href);
    }
  };

  return (
    <>
      <Breadcrumbs
        items={breadcrumbItems}
        separator=">"
        currentPath={location.pathname}
        onClick={handleBreadcrumbClick}
      />
      <SC.BodyContainer>
        <SC.Container>
          <InnoTable
            tableConfig={tableConfig}
            loading={isLoading}
            padding="4px 8px"
            column={subColumnData}
            data={projects}
            tableKey="Project"
            ComponnentName="Project"
            searchKeys={["propertyName", "displayTemplateName"]}
            onRowClickCallback={onRowClick}
            onAddDataCallback={onAddDataCallback}
            onRow={(record) => ({
              onClick: (event) => {
                setTimeout(() => {
                  if (!document.querySelector(".ant-image-preview-mask")) {
                    handlelevelClick(record);
                  }
                }, 100);
              },
            })}
          />
        </SC.Container>
      </SC.BodyContainer>
      {open && (
        <DetailDrawer
          open={open}
          onClose={closeDrawer}
          title={false}
          width={"650px"}
          children={
            <AddEditProjects
              projectdata={rowData}
              onClose={closeDrawer}
              isEditing={isEditing}
              setIsEditing={setIsEditing}
              rowId={rowId}
              setProjects={setProjects}
              fetchData={getAllProjects}
            />
          }
        ></DetailDrawer>
      )}
      {openAssignUserDrawer && (
        <DetailDrawer
          open={openAssignUserDrawer}
          onClose={closeAssignUserDrawer}
          width={"70%"}
          children={
            <AssignUser
              // userdata={fieldData}
              onClose={closeAssignUserDrawer}
              project={rowData}
              // fetchData={getAlldata}
            />
          }
        />
      )}
      {openFolderStructure && (
        <DetailDrawer
          open={openFolderStructure}
          onClose={closeFolderStructure}
          closable={true}
          width={"70%"}
          children={
            <FolderProjectStructure
              onClose={closeFolderStructure}
              rowData={rowData}
              projectType={projectType.property}
            />
          }
        />
      )}

      {openModal && (
        <ExportPropertyModal
          setOpenModal={setOpenModal}
          openModal={openModal}
          rowData={rowData}
          projectType={0}
        />
      )}

      {openDrwer && (
        <DetailDrawer
          open={openDrwer}
          onClose={closeLinkProjectDrawer}
          title={false}
          width={"650px"}
          children={
            <LinkProjects
              onClose={closeLinkProjectDrawer}
              projectData={rowData}
              // setSelectedItem={setSelectedItems}
              fetchData={getAllProjects}
              setOpenDrwer={setOpenDrwer}
            />
          }
        />
      )}

      {openDeleteView && (
        <DeleteComponent
          title={"Delete User"}
          messageData={`Are you sure you want to delete user ${
            rowData?.propertyName || ""
          }?`}
          setOpenDeleteView={setOpenDeleteView}
          openDeleteView={openDeleteView}
          handleDelete={() => handleDelete(fieldId)}
          handleArchive={() => setOpenDeleteView(false)}
          firstButtontext={"Cancel"}
        />
      )}
    </>
  );
};

export default Projects;
